import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';

import { IceapiService } from '../../../../../services/index';
import { HubMaterialModel } from '../../../models/index';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-hub-material',
    templateUrl: './hub-material.component.html',
    styleUrls: ['./hub-material.component.scss'],
    standalone: false
})
export class HubMaterialComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Output() selected: EventEmitter<HubMaterialModel> = new EventEmitter();

    @Input()
    set clampMaterialId(value: string) {
        this._clampMaterialId = value;
        if (!this.jointCalcService.isPipeCode) this.getHubMaterials();
    }
    get clampMaterialId(): string {
        return this._clampMaterialId;
    }
    destroy$ = new Subject();
    tooltip_position = 'above';
    loading: boolean = false;
    public optionList: HubMaterialModel[] = [];

    private _clampMaterialId: string;
    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}
    ngOnInit(): void {
        if ((this.jointCalcService.isPipeCode && this.router.url.includes('/idms/plantmanagerView')) || this.router.url == '/idms/plantmanager') {
            this.pipespecwithsealRingMaterial();
        }
        this.form
            .get('hubMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value)
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                        this.jointCalcService.selectedhubMaterial.next(value);
                    }
            });
    }

    private getHubMaterials(): void {
        this.form.markAllAsTouched();
        if (!this.clampMaterialId) return;
        this.loading = true;

        this.iceapi
            .getHubMaterials(this.clampMaterialId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((hubMaterials) => {
                if (hubMaterials.success === true) {
                    this.optionList = hubMaterials.response;
                    this.cd.markForCheck();
                    if (this.form.get('hubMaterial').value) {
                        this.dataService.selectedHubMaterial = this.optionList.find((x) => x.hubMaterialId === this.form.get('hubMaterial').value).name;
                    }
                    if (this.optionList.length === 1) {
                        this.form.get('hubMaterial').patchValue(this.optionList[0].hubMaterialId, { emitEvent: false });
                        this.form.get('hubMaterial').updateValueAndValidity();
                        this.selected.emit(this.optionList[0]);
                        this.dataService.selectedHubMaterial = this.optionList[0].name;
                    }
                } else {
                    this.user_utility.errorModelPopup(hubMaterials.message);
                }
            });
    }

    selectHubMaterial(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.hubMaterialId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
            this.dataService.selectedHubMaterial = selection.name;
        }
        this.form.markAllAsTouched();
    }
    async pipespecwithsealRingMaterial() {
        this.jointCalcService.selectedPipeSchedule.pipe(takeUntil(this.destroy$)).subscribe(async (ps) => {
            if (ps) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                inputGroup.recordId.sealRingMaterialId = inputGroup.recordId.sealRingId = inputGroup.others.boltType = null;
                inputGroup.recordId.pipeScheduleId = ps;

                this.loading = true;
                let pipespechubMaterial = await this.iceapi
                    .getHubMaterials(this.clampMaterialId)
                    .pipe(finalize(() => {
                        this.loading = false;
                        this.cd.detectChanges();
                    }))
                    .toPromise();

                if (pipespechubMaterial.success) {
                    this.optionList = [...pipespechubMaterial.response];

                    this.optionList = await this.jointCalcService.managePayloadForRecourdId('hubMaterialId', this.optionList);

                    if (this.dataService?.calculationData?.input?.recordId?.hubMaterialId)
                        this.form.get('hubMaterial').setValue(this.dataService?.calculationData?.input?.recordId?.hubMaterialId);
                    else if (this.optionList.length === 1) this.form.get('hubMaterial').setValue(this.optionList[0].hubMaterialId);
                } else if (pipespechubMaterial.isCustom) {
                    this.user_utility.errorModelPopup(pipespechubMaterial.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
